import { useDispatch } from 'react-redux';
import { call, select, takeEvery } from 'redux-saga/effects';
import { selectCartTotals } from '../../App/selectors';
import { handleCheckout } from '../components/form/saga-checkout';
import type { OrderWithAccountCreated, PurchaseResult } from '../../../__generated__/graphql';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Pricing } from '@ticketmaster/tm1pos-web-shared/model/graphql';

const DELIVER_THROUGH_LEGACY_FLOW = 'DELIVER_THROUGH_LEGACY_FLOW';

export const useDeliveryBridge = () => {
  const dispatch = useDispatch();

  const deliver = (purchaseResult: OrderWithAccountCreated) => {
    dispatch({ type: DELIVER_THROUGH_LEGACY_FLOW, payload: purchaseResult });
  };

  return { deliver };
};

function* handleLegacyDeliveryBridge(action: PayloadAction<PurchaseResult>) {
  const totals: Pricing = yield select(selectCartTotals);
  if (action?.payload.__typename === 'OrderWithAccountCreated') {
    const order = action.payload;
    yield call(handleCheckout, {
      data: {
        checkout: {
          order: {
            accountId: order.accountId,
            id: order.orderId,
            totals,
            payments: [],
          },
        },
      },
    });
  }
}

export function* watchLegacyDeliveryBridge() {
  yield takeEvery(DELIVER_THROUGH_LEGACY_FLOW, handleLegacyDeliveryBridge);
}
